import type { FC } from 'react';
import type { StrapiSubCategory } from '../../../../@types/gql/products-listing';

const ProductCategoryInfo: FC<StrapiSubCategory> = ({ Title }) => {
  return (
    <div className="mb-2 px-6 max-md:px-0">
      <h1 className="text-4xl mb-6 mt-8 font-bold max-md:text-2xl max-md:mt-6">
        {Title}
      </h1>
      {/*<Markdown className="rich-text-view opacity-80">{Description}</Markdown>*/}
    </div>
  );
};

export default ProductCategoryInfo;
